import {
  GET_LABREQUESTREPORTROI,
  GET_LABREQUESTREPORTROI_FAIL,
  GET_LABREQUESTREPORTROI_SUCCESS,
  GET_LABREQUESTREPORTROIS,
  GET_LABREQUESTREPORTROIS_FAIL,
  GET_LABREQUESTREPORTROIS_SUCCESS,
  ADD_NEW_LABREQUESTREPORTROI,
  ADD_LABREQUESTREPORTROI_SUCCESS,
  ADD_LABREQUESTREPORTROI_FAIL,
  UPDATE_LABREQUESTREPORTROI,
  UPDATE_LABREQUESTREPORTROI_SUCCESS,
  UPDATE_LABREQUESTREPORTROI_FAIL,
  DELETE_LABREQUESTREPORTROI,
  DELETE_LABREQUESTREPORTROI_SUCCESS,
  DELETE_LABREQUESTREPORTROI_FAIL,
  SET_STATE_LABREQUESTREPORTROI
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTREPORTROI,
  payload: loading,
})

export const getLabRequestReportRois = ( params ) => ({
  type: GET_LABREQUESTREPORTROIS,
  payload: { params },
})

export const getLabRequestReportRoisSuccess = (labRequestReportRois, totalPages, currentPage) => ({
  type: GET_LABREQUESTREPORTROIS_SUCCESS,
  payload: { labRequestReportRois:labRequestReportRois, total:totalPages, currentPage:currentPage}
})

export const getLabRequestReportRoisFail = error => ({
  type: GET_LABREQUESTREPORTROIS_FAIL,
  payload: error,
})

export const addNewLabRequestReportRoi = labRequestReportRoi => ({
  type: ADD_NEW_LABREQUESTREPORTROI,
  payload: labRequestReportRoi,
})

export const addLabRequestReportRoiSuccess = labRequestReportRoi => ({
  type: ADD_LABREQUESTREPORTROI_SUCCESS,
  payload: labRequestReportRoi,
})  

export const addLabRequestReportRoiFail = error => ({
  type: ADD_LABREQUESTREPORTROI_FAIL,
  payload: error,
})

export const updateLabRequestReportRoi = labRequestReportRoi => ({
  type: UPDATE_LABREQUESTREPORTROI,
  payload: labRequestReportRoi,
})

export const updateLabRequestReportRoiSuccess = labRequestReportRoi => ({
  type: UPDATE_LABREQUESTREPORTROI_SUCCESS,
  payload: labRequestReportRoi,
})

export const updateLabRequestReportRoiFail = error => ({
  type: UPDATE_LABREQUESTREPORTROI_FAIL,
  payload: error,
})

export const deleteLabRequestReportRoi = labRequestReportRoi => ({
  type: DELETE_LABREQUESTREPORTROI,
  payload: labRequestReportRoi,
})

export const deleteLabRequestReportRoiSuccess = id => ({
  type: DELETE_LABREQUESTREPORTROI_SUCCESS,
  id,
})

export const deleteLabRequestReportRoiFail = error => ({
  type: DELETE_LABREQUESTREPORTROI_FAIL,
  payload: error,
})

export const getLabRequestReportRoi = () => ({
  type: GET_LABREQUESTREPORTROI,
})

export const getLabRequestReportRoiSuccess = labRequestReportRoi => ({
  type: GET_LABREQUESTREPORTROI_SUCCESS,
  payload: labRequestReportRoi,
})

export const getLabRequestReportRoiFail = error => ({
  type: GET_LABREQUESTREPORTROI_FAIL,
  payload: error,
})
